import {
  AllCommunityModule,
  ClientSideRowModelModule,
  ModuleRegistry,
  ValidationModule,
} from "ag-grid-community";
import {
  CellSelectionModule,
  ClipboardModule,
  ExcelExportModule,
  RowGroupingModule,
  RowGroupingPanelModule,
} from "ag-grid-enterprise";
import { RequestHelper } from "../../../utils/requestHelper";
import { useEffect, useState } from "react";
import { _COLORS } from "../../../utils/constants";
import { getDataGeneric } from "../../../repository/DataGeneric";
import { _ROUTES } from "../../../utils/_routes_constants";
import { DataTable } from "../../ui/DataTable";
import { ColumnBuilder } from "./ColumnBuilder";
import { useSalesOnCellValueChanged } from "./useSaveSalesOnCellChanged";

ModuleRegistry.registerModules([
  AllCommunityModule,
  ExcelExportModule,
  ClientSideRowModelModule,
  ValidationModule,
  RowGroupingModule,
  RowGroupingPanelModule,
  CellSelectionModule,
  ClipboardModule,
]);

/**
 *
 * @param {string}params.site
 * @param {string} params.fiscalYear
 * @param {string} params.version
 * */
export default function AgGridDepreciation({
  params,
  rowsData,
  setRowsData,
  gridRef,
}) {
  const requestHelper = new RequestHelper();
  const [columns] = useState(ColumnBuilder());

  useEffect(() => {
    if (!params?.site) {
      return;
    }
    const queryParams = {
      site: params.site,
    };

    if (params.fiscalYear) queryParams.fiscalYear = params.fiscalYear;
    if (params.version) queryParams.version = params.version;

    getDataGeneric(
      requestHelper,
      queryParams,
      (data) => {
        setRowsData(data);
      },
      _ROUTES.GET_IPT_DEPRECIATION,
      "Unable to retrieve depreciations rows",
    );
  }, [params.site]);

  const onCellValueChanged = useSalesOnCellValueChanged(params, gridRef);

  const defaultColDef = {
    cellClassRules: {
      "total-header-col": (params) => {
        return params.colDef.field === "total";
      },
      "total-row": (params) =>
        params.node && params.node.aggData && params.node.footer,
    },
  };

  const excelStyles = [
    {
      id: "month-header",
      interior: {
        color: _COLORS.headerAgGrid,
        pattern: "Solid",
      },
    },
    {
      id: "total-header-col",
      interior: {
        color: _COLORS.totalAgGrid,
        pattern: "Solid",
        font: {
          bold: true,
        },
      },
    },
    {
      id: "total-row",
      class: "total-row",
      interior: {
        color: _COLORS.totalLabourRow,
        pattern: "Solid",
      },
      font: {
        bold: true,
      },
    },
  ];

  return (
    <>
      <DataTable
        rows={rowsData}
        columns={columns}
        excelStyles={excelStyles}
        onCellValueChanged={onCellValueChanged}
        fullHeight={true}
        gridRef={gridRef}
        rowHeight={30}
        agGridProps={{
          cellSelection: true,
          copyHeadersToClipboard: false,
          defaultColDef: defaultColDef,
          groupDisplayType: "groupRows",
          suppressAggFuncInHeader: true,
          getRowClass: (params) => {
            if (!params.data) {
              return "header-group-row";
            }
            return null;
          },
        }}
      />
    </>
  );
}
